import { atom } from "jotai";

export const dropDownMenuAtom = atom({
  orderIsExpedited: false,
  orderStatus: false,
});
